// LEGACY Editor.js block tool for the contact-form marker. Superseded by the
// form-builder "form" block: it has no toolbox entry, so it can't be added any
// more, but it stays registered so pages that still contain a contactForm
// block keep it through an edit (the live template renders the real
// <ContactForm> where it sits — see PageBody.astro / render-blocks.ts).

const ICON =
  '<svg width="17" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v16H4z"/><path d="m4 7 8 5 8-5"/></svg>';

export class ContactFormTool {
  // Block holds no editable content.
  static get contentless() {
    return true;
  }

  render() {
    const wrap = document.createElement("div");
    wrap.contentEditable = "false";
    wrap.className = "ce-contact-form-block";
    wrap.setAttribute("style", [
      "display:flex",
      "align-items:center",
      "gap:.5rem",
      "padding:.875rem 1rem",
      "border:1px dashed var(--border, #d4d4d8)",
      "border-radius:.5rem",
      "color:var(--muted-foreground, #71717a)",
      "font-size:.875rem",
      "background:var(--muted, #fafafa)",
    ].join(";"));
    wrap.innerHTML = `${ICON}<span>Contact form — your live contact form appears here on the published page.</span>`;
    return wrap;
  }

  save() {
    return {};
  }

  static get sanitize() {
    return {};
  }
}
